import React from 'react'
import { TextLink, Text } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Region } from '@moonpig/web-core-types'

const Link = styled(TextLink)`
  text-decoration: underline;
  font-weight: 400;
  ${s({
    color: 'colorInteractionSelectedState',
  })}

  &:hover {
    text-decoration-thickness: 2px;
  }
`

export const TermsAndConditions = ({ region }: { region: Region }) => {
  if (region === 'nl') {
    return (
      <Text mt={10} mb={10} typography="typeBodyText" as="p">
        Door verder te gaan, ga ik akkoord met de algemene voorwaarden en{' '}
        <Link
          href={`/${region}/voorwaarden/privacy-reglement-greetz/app/`}
          target="_blank"
        >
          privacybeleid
        </Link>
        . Voor onze consumenten hanteren wij de{' '}
        <Link href={`/${region}/voorwaarden/app/`} target="_blank">
          Algemene Voorwaarden Thuiswinkel
        </Link>{' '}
        en onze{' '}
        <Link
          href={`/${region}/voorwaarden/onze-voorwaarden-aanvulling/`}
          target="_blank"
        >
          Aanvullende Voorwaarden voor Consumenten
        </Link>
        .
      </Text>
    )
  }
  return (
    <Text mt={10} mb={10} typography="typeBodyText" as="p">
      By continuing, I agree to Moonpig&apos;s{' '}
      <Link href={`/${region}/terms-and-conditions/`} target="_blank">
        terms and conditions
      </Link>
      , have read the{' '}
      <Link href={`/${region}/privacy-notice/`} target="_blank">
        privacy notice
      </Link>
      , and am at least 18 years old.
    </Text>
  )
}
